import React from "react";
import { CorrespondenceForm } from "../forms/correspondence/CorrespondenceForm";

interface CorrespondenceFlowProps {
  onBackToDashboard?: () => void;
}

export const CorrespondenceFlow: React.FC<CorrespondenceFlowProps> = ({
  onBackToDashboard,
}) => {
  const handleBackClick = () => {
    if (onBackToDashboard) {
      onBackToDashboard();
    }
  };

  return (
    <div className="document-flow-container">
      <div className="flow-header">
        <h2>Write Correspondence</h2>
        <button className="back-button" onClick={handleBackClick}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
          Back
        </button>
      </div>
      <CorrespondenceForm onBack={handleBackClick} />
    </div>
  );
};
